import { GridRequest } from 'projects/app-core/src/models/gridRequest';
import { GridResponse } from 'projects/app-core/src/models/gridResponse';

export enum LyfisPersistedUserScoresSort {
  CREATED_AT = 'createdAt',
  GHS = 'ghs',
  DISEASE_SCORE_IDS_COUNT = 'diseaseScoreIdsCount',
}

export enum LyfisPersistedUserScoresFilter {
  TRIGGER = 'trigger',
  GHS_BAND = 'ghsBand',
  GLOBAL_INSIGHTS_GENERATING_STATUS = 'globalInsightsGeneratingStatus',
  PARTNER_ID = 'partnerId',
  TEST_USERS = 'TEST_USERS',
}

export enum LyfisPersistedUserScoresSearch {
  PARTNER_ID = 'partnerId',
}

export enum LyfisPersistedUserScoresDateFilter {
  CREATED_AT = 'createdAt',
}

export interface LyfisPersistedUserScoresGridRequest
  extends GridRequest<
    LyfisPersistedUserScoresSort,
    LyfisPersistedUserScoresFilter,
    LyfisPersistedUserScoresSearch,
    LyfisPersistedUserScoresDateFilter
  > {}

export interface LyfisPersistedUserSnapshotRow {
  id: string;
  createdAt?: number;
  trigger?: 'lab' | 'questionnaire';
  ghs: number;
  ghsBand: string | null;
  diseaseScoreIdsCount: number;
  labReportIdsUsedCount: number;
  globalInsightsGeneratingStatus?: string;
  partnerId?: string;
}

export interface LyfisPersistedUserScoresFilterData {
  trigger?: string[];
  ghsBand?: string[];
  globalInsightsGeneratingStatus?: string[];
  partnerId?: string[];
}

export interface LyfisPersistedUserScoresGridResponse
  extends GridResponse<
    LyfisPersistedUserScoresFilterData | undefined,
    LyfisPersistedUserSnapshotRow
  > {}
